import Cookies from 'js-cookie';

import { COOKIE_NAME_BROWSING_HISTORY, MAX_HISTORY } from './constants';
import type { BrowsingHistoryItem } from './types';

export function saveBrowsingHistory(car: BrowsingHistoryItem) {
  if (typeof window === 'undefined') return;

  Cookies.remove(COOKIE_NAME_BROWSING_HISTORY);
  let history: BrowsingHistoryItem[] = localStorage.getItem(COOKIE_NAME_BROWSING_HISTORY) // @suppress longLineCheck
    ? JSON.parse(localStorage.getItem(COOKIE_NAME_BROWSING_HISTORY) as string)
    : [];

  history = history.filter(item => item.id !== car.id);

  history.push(car);

  if (history.length > MAX_HISTORY) {
    history.shift();
  }

  localStorage.setItem(COOKIE_NAME_BROWSING_HISTORY, JSON.stringify(history));
}

/**
 * Retrieve browsing history from localStorage
 * @returns {BrowsingHistoryItem[]} Browsing history
 */
export function getBrowsingHistory(): BrowsingHistoryItem[] {
  if (typeof window === 'undefined') return [];

  return localStorage.getItem(COOKIE_NAME_BROWSING_HISTORY)
    ? JSON.parse(localStorage.getItem(COOKIE_NAME_BROWSING_HISTORY) as string)
    : [];
}

/**
 * Clear all browsing history
 */
export function clearBrowsingHistory() {
  if (typeof window === 'undefined') return;

  localStorage.removeItem(COOKIE_NAME_BROWSING_HISTORY);
}
